import { Routes } from '@angular/router';

import { DefaultLayoutComponent } from './layout';
import { PagenotfoundComponent } from './pagenotfound/pagenotfound.component';
import { DownloadComponent } from './download/download.component';
import { ReferComponent } from './misc/refer/refer.component';
import { ApiaccessComponent } from './misc/apiaccess/apiaccess.component';
import { LogoutComponent } from './logout/logout.component';
import { LinkedinCommentsInsightsComponent } from './views/social-media/linkedin-comments-insights/linkedin-comments-insights.component';

export const routes: Routes = [

    { path: '', redirectTo: 'dashboard', pathMatch: 'full' },

    {
        path: '',
        component: DefaultLayoutComponent,
        data: { title: 'Home' },
        children: [
            { path: 'dashboard', loadChildren: () => import('./views/dashboard/routes').then(m => m.routes) },
            { path: 'administration-and-configuration', loadChildren: () => import('./views/administration-and-configuration/routes').then((m) => m.routes) },
            { path: 'generative-ai', loadChildren: () => import('./views/generative-ai/routes').then((m) => m.routes) },
            { path: 'social-media', loadChildren: () => import('./views/social-media/routes').then((m) => m.routes) },
            { path: 'language-detection', loadChildren: () => import('./views/language-detection/routes').then((m) => m.routes) },
            { path: 'optical-character-recognition', loadChildren: () => import('./views/optical-character-recognition/routes').then((m) => m.routes) },
            { path: 'subscribe', loadChildren: () => import('./views/subscribe/routes').then((m) => m.routes) },
            { path: 'text-to-speech', loadChildren: () => import('./views/text-to-speech/routes').then((m) => m.routes) },
            { path: 'transcription-speech-to-text', loadChildren: () => import('./views/transcription-speech-to-text/routes').then((m) => m.routes) },
            { path: 'translation', loadChildren: () => import('./views/translation/routes').then((m) => m.routes) },
            { path: 'notifications', loadChildren: () => import('./notifications/routes').then((m) => m.routes) },
            { path: 'refer', loadChildren: () => import('./refer/routes').then((m) => m.routes) },
            { path: 'specific-user', loadChildren: () => import('./views/userspecific/routes').then((m) => m.routes) },

            {
                path: 'download',
                component: DownloadComponent
            },
            {
                path: 'usage',
                loadChildren: () => import('./views/usage/routes').then((m) => m.routes)
            },
            {
                path: 'refer',
                component: ReferComponent
            },
            {
                path: 'access-to-api-keys',
                component: ApiaccessComponent
            },
            {
                path: 'transactions',
                loadChildren: () => import('./views/transactions/routes').then((m) => m.routes)

            },
            {
                path:'dummy',
                component:LinkedinCommentsInsightsComponent
            },
            {
                path: 'logout',
                component: LogoutComponent
            }

        ]
    },

    { path: '**', redirectTo: 'dashboard' },
    { path: '404', component: PagenotfoundComponent, data: { title: 'Page 404' } },

];

